export default __webpack_public_path__ + "static/media/travel_packages.09eb6406.png";